module.exports = __webpack_public_path__ + "a0568653283431ae61b03addac19ef96.pdf";